/* global globals */
import get from 'lodash/get';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';
import VerificationStore from '../stores/VerificationStore';

const { ActionTypes } = Constants;

module.exports = {
  submitCapturedImage() {
    const formData = new FormData();

    const capturedImage = VerificationStore.getCapturedImage();
    formData.append('image', capturedImage);

    fetch(`${get(globals, 'apiWebroot', '/')}verification/submit`, {
      method: 'post',
      credentials: 'include',
      body: formData,
    }).then((resp) => resp.json()).then((data) => {
      if (typeof data.status !== 'undefined' && data.status === 'ok') {
        AppDispatcher.dispatch({
          type: ActionTypes.VERIFICATION_IMAGE_SUBMIT_SUCCESS,
          filename: data.filename || '',
        });
      } else {
        AppDispatcher.dispatch({
          type: ActionTypes.VERIFICATION_IMAGE_SUBMIT_ERROR,
          msg: data.msg || 'txt: Nezināma kļūda',
          retake: data.retake || false,
          myStatus: typeof data.myStatus !== 'undefined' ? data.myStatus : undefined,
          myImage: typeof data.myImage !== 'undefined' ? data.myImage : undefined,
        });
      }
    }).catch((data) => {
      console.log(data);
      AppDispatcher.dispatch({
        type: ActionTypes.VERIFICATION_IMAGE_SUBMIT_ERROR,
      });
    });
  },
};
